import { randomArray } from "@library/common";
import { MockPagination, MockPath } from "@library/common/http/mock-path.mock";
import { QuoteFactory } from "@library/common/models/mock";
import { Quotation } from "@library/common/models";
import { MockQuotationSnapshot } from "./snapshot/quotation-snapshot.mock";

export const QuotationRoutes: MockPath<Quotation<any, any>>[] = [
    {
        path: 'quotations/view',
        verb: 'POST',
        type: 'quote',
        collection: () => [ QuoteFactory.mock() ],
    },
    {
        path: 'quotations/list',
        verb: 'POST',
        type: 'quote',
        response: opts => ({
            collection: randomArray( MockQuotationSnapshot, 15, 10 ),
            pagination: MockPagination( opts?.body?.pagination ),
        }),
    },
];